<template>
	<multi-tags
		v-if="tags.length > 0 && tags.indexOf('N/S') == -1"
		:tags="options.showMissing ? tagsWithMissing : tags"
		:class-joiner="'gender-group'"
		v-bind="options"
	/>
</template>

<script>
	import MultiTags from '@/components/MultiTags.vue';

	import multiTagsMixin from '@/mixins/multiTagsMixin.js';

	export default {
		name: "GenderGroupTags",
		components: {
			MultiTags
		},
		mixins: [multiTagsMixin],
		props: {
			tags: {
				type: Array,
				required: true,
			},
			options: {
				type: Object,
				default: () => ({})
			},
		},
		beforeCreate() {
			this.allTags = ["Men", "Women", "Coed"];
		}
	}
</script>

<style lang="scss">
.multi-tag {
	&.gender-group--Men {
		color: blueviolet;
	}
	&.gender-group--Women {
		color: blueviolet;
	}
	&.gender-group--Coed {
		color: blueviolet;
	}
}
</style>